// extracted by mini-css-extract-plugin
module.exports = {"page":"Product_page__36fbW","main":"Product_main__1SFjo","imageImg":"Product_imageImg__2n7R1","info":"Product_info__1BbAr"};